import { createWebHistory, createRouter } from "vue-router";

const routes = [

    {
        path: "/",
        alias: "/",
        name: "login",
        component: () => import("../components/Login")
    },
    {
        path: "/register",
        alias: "/register",
        name: "register",
        component: () => import("../components/Register")
    },
    {
        path: "/forgotPassword",
        alias: "/forgotPassword",
        name: "forgotPassword",
        component: () => import("../components/ForgotPassword")
    },
    {
        path: "/verifySentCode",
        alias: "/verifySentCode",
        name: "verifySentCode",
        component: () => import("../components/VerifySentCode")
    },
    {
        path: "/googleCallback",
        alias: "/googleCallback",
        name: "googleCallback",
        component: () => import("../components/GoogleCallback")
    },
    {
        path: "/changePassword",
        alias: "/changePassword",
        name: "changePassword",
        component: () => import("../components/ChangePassword")
    },
    {
        path: "/changePasswordForce",
        alias: "/changePasswordForce",
        name: "changePasswordForce",
        component: () => import("../components/ChangePasswordForce")
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;